import { ACCOUNT_NICKNAME_REGEX } from 'shared/utils/string/accountNickname';
import { z } from 'zod';

export const accountNicknameValidationMessages = {
  invalid_minimum_length: 'manageAccount.editAccountName.invalidMinLength',
  invalid_characters: 'manageAccount.editAccountName.invalidCharacters',
};

export const accountNicknameSchema = z
  .string()
  .min(3, { error: accountNicknameValidationMessages.invalid_minimum_length })
  .regex(ACCOUNT_NICKNAME_REGEX, {
    error: accountNicknameValidationMessages.invalid_characters,
  });
